import type {
  CreateInvitationRequest,
  CreateInvitationResponse,
  ListInvitationsResponse,
  ResendInvitationResponse,
} from '@jq4race/shared';
import { request } from './client.js';

export async function createInvitation(
  input: CreateInvitationRequest,
): Promise<CreateInvitationResponse> {
  return request<CreateInvitationResponse>('/auth/invitations', {
    method: 'POST',
    body: input,
  });
}

export async function resendInvitation(invitationId: string): Promise<ResendInvitationResponse> {
  return request<ResendInvitationResponse>(
    `/auth/invitations/${encodeURIComponent(invitationId)}/resend`,
    { method: 'POST' },
  );
}

export async function listInvitations(): Promise<ListInvitationsResponse> {
  return request<ListInvitationsResponse>('/auth/invitations', {
    method: 'GET',
  });
}
